export const LOGO_URL = "/brand/logo.png";

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  sales_manager: "Sales Manager",
  admin_manager: "Admin Manager",
  sales_consultant: "Sales Consultant",
  admin_consultant: "Admin Consultant",
  prepost: "Pre/Post Officer",
};

export const ROLES = Object.keys(ROLE_LABELS);

export const MODULES = [
  { key: "dashboard", label: "Dashboard", path: "/app", icon: "LayoutDashboard" },
  { key: "leads", label: "Leads", path: "/app/leads", icon: "Users" },
  { key: "kanban", label: "Pipeline", path: "/app/kanban", icon: "Kanban" },
  { key: "prepost", label: "Pre/Post", path: "/app/prepost", icon: "ClipboardCheck" },
  { key: "calendar", label: "Calendar", path: "/app/calendar", icon: "Calendar" },
  { key: "quotes", label: "Quotes", path: "/app/quotes", icon: "FileText" },
  { key: "plenti", label: "Plenti calculation", path: "/app/plenti", icon: "Calculator" },
  { key: "messages", label: "Messages", path: "/app/messages", icon: "MessageSquare" },
  { key: "templates", label: "Templates", path: "/app/templates", icon: "FileStack" },
  { key: "payments", label: "Payments", path: "/app/payments", icon: "CreditCard" },
  { key: "products", label: "Products", path: "/app/products", icon: "Package" },
  { key: "reports", label: "Reports", path: "/app/reports", icon: "BarChart3" },
  { key: "timesheets", label: "Timesheets", path: "/app/timesheets", icon: "Clock" },
  { key: "calllog", label: "Call Log", path: "/app/calllog", icon: "PhoneCall" },
  { key: "users", label: "Users", path: "/app/users", icon: "UserCog" },
  { key: "superadmin", label: "Super Admin", path: "/app/superadmin", icon: "ShieldCheck" },
  { key: "settings", label: "Settings", path: "/app/settings", icon: "Settings" },
];

export const AU_STATES = ["VIC", "NSW", "QLD", "SA", "WA", "TAS", "NT", "ACT"];

export const INTERESTED_SOLUTIONS = [
  "Only Home Battery Solutions",
  "Solar Panels + Home Battery Combo Offers",
  "Only Solar Panels System",
];

export const LEAD_PRIORITIES = ["Low", "Medium", "High", "Urgent"];

export const PREPOST_EDIT_ROLES = ["super_admin", "admin", "sales_manager", "admin_manager", "prepost"];

export const SOLAR_VIC_STATUS = [
  "Not eligible", "Pending to be applied", "Quote submitted", "Quote expired",
  "Customer application approved", "Customer application cancelled",
  "Under review awaiting response", "Solar VIC payment claimed", "Payment processed",
];

export const DISTRIBUTOR_POST_INSTALL = ["Application Pending", "Submitted"];

export const MANAGER_ROLES = ["super_admin", "admin", "sales_manager", "admin_manager"];

export const PROPERTY_OPTIONS = {
  property_type: ["Residential", "Commercial"],
  no_of_stories: ["Single", "Double", "Multi"],
  roof_type: ["Metal Tin", "Colourbond TIN", "Tile", "TIN with Kliplock", "Standard TIN"],
  roof_pitch: ["Standard Tilted", "Flat", "Stiff Tilt"],
  tilt_requirement: ["Yes", "No"],
  phase: ["Single", "Three"],
  switchboard: ["No Upgrade Required", "Partial Upgrade Required", "Full Upgrade Required"],
  internet: ["Working Wifi", "No Internet"],
  distributor: ["Jemena", "Ausnet", "Powercor", "United Energy"],
};

export const QUOTE_TYPES = [
  { key: "pv", label: "Solar PV Only" },
  { key: "battery", label: "AC Coupled Battery Only" },
  { key: "hybrid", label: "Hybrid DC Coupled Solar PV & Battery" },
];

export const ACTIVITY_TYPES = [
  { key: "call_pickup", label: "Call - Picked Up" },
  { key: "call_no_answer", label: "Call - Didn't Pick Up" },
  { key: "email_sent", label: "Email Sent" },
  { key: "sms_sent", label: "SMS Sent" },
  { key: "note", label: "Note" },
];

export const currency = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const naive = typeof iso === "string" && iso.includes("T") && !/(Z|[+-]\d{2}:\d{2})$/.test(iso);
  const d = new Date(naive ? `${iso}Z` : iso);
  return d.toLocaleString("en-AU", { timeZone: naive ? "UTC" : "Australia/Melbourne", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
